var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44.8 35.6",
    style: {
      enableBackground: "new 0 0 44.8 35.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n\t.st1{fill:#FF6666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1571_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1572_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1574_",
    className: "st0",
    d: "M22.4,7.2l-16,13.2c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1v13.3c0,0.5,0.2,0.9,0.5,1.2 c0.4,0.4,0.8,0.5,1.2,0.5h10.7V25h7.1v10.7h10.7c0.5,0,0.9-0.2,1.2-0.5c0.4-0.4,0.5-0.8,0.5-1.2V20.5c0-0.1,0-0.1,0-0.2L22.4,7.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1573_",
    className: "st1",
    d: "M44.4,17.4l-6.1-5.1V1c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.2-0.6-0.2h-5.3 c-0.3,0-0.5,0.1-0.6,0.2c-0.2,0.2-0.2,0.4-0.2,0.6v5.4l-6.8-5.7C23.9,0.2,23.2,0,22.4,0c-0.8,0-1.5,0.2-2.1,0.7l-20,16.6 C0.1,17.5,0,17.7,0,17.9c0,0.2,0,0.5,0.2,0.7l1.7,2.1c0.1,0.2,0.3,0.3,0.6,0.3c0.2,0,0.4,0,0.7-0.2l19.2-16l19.2,16 c0.1,0.1,0.3,0.2,0.6,0.2h0.1c0.2,0,0.4-0.1,0.6-0.3l1.7-2.1c0.1-0.2,0.2-0.4,0.2-0.7C44.7,17.7,44.6,17.5,44.4,17.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.69532736d2b8788d59d3fdeeb6a9b2ba.svg";
export { ForwardRef as ReactComponent };